export const handlePomaUserRecovery = ({ authEventHandler, email }) => {
    authEventHandler({
        event: 'isPomaUser',
        data: { email },
    });
};
